











































































import { Vue, Component, Prop } from 'vue-property-decorator';
import AMSformTable from '@/components/AMSformTable.vue';
import AMSTable from '@/components/AMSTable.vue';
import AMSImg from '@/components/AMSImg.vue';
import request from '@/utils/request';
import AMSDialog from '@/components/AMSDialog.vue';
import { AppStore } from '@/store/modules/app';
import moment from 'moment';
import { getInstock, getStockLog, approveStock } from '@/api/stock';
import AMSBreadcrumb from '@/components/AMSBreadcrumb.vue';
import AMSOperateLogs from '@/components/AMSOperateLogs.vue';
import Utils from '@/utils/utils';
interface Product {
  name?: string;
  serialNumber?: string;
  capacity?: string;
  orderPrice?: Number;
  sort?: Number;
  stockQuantity?: Number;
  category?: Warehouse;
  creationTime?: String;
  status?: string;
  id?: string;
}
interface Products {
  stockId?: string;
  productId?: string;
  product?: Product;
  quantity?: Number;
}
interface Warehouse {
  name?: string;
  id?: string;
}
interface Form {
  warehouseId?: string;
  warehouse?: Warehouse;
  products?: Products[];
  number?: string;
  type?: string;
  quantity?: Number;
  operator?: string;
  stockTime?: String;
  status?: string;
  id?: string;
}
@Component({
  components: {
    'ams-formtable': AMSformTable,
    'ams-table': AMSTable,
    'ams-dialog': AMSDialog,
    'ams-breadcrumb': AMSBreadcrumb,
    'ams-operate-logs': AMSOperateLogs
  }
})
export default class StockDetail extends Vue {
  breadcrumbsItems = [
    {
      text: '库存管理',
      disabled: false,
      href: '/inStock'
    },
    {
      text: '入库单',
      disabled: false,
      href: '/inStock'
    },
    {
      text: this.isEdit() ? '审核入库单' : '入库单详情',
      disabled: true
    }
  ];

  form: Form = {};
  logs: Array<any> = [];
  dialog = false;
  requestLoading = false;
  headers = [
    { text: '编号', value: 'serialNumber', sortable: false, align: 'right' },
    {
      text: '图片',
      value: 'pictureKey',
      align: 'left',
      sortable: false,
      render: (h: Function, param: any) => {
        return h(AMSImg, {
          props: {
            pictureKey: param.row.pictureKey,
            pictureWidth: 40,
            pictureHeight: 40
          }
        });
      }
    },
    { text: '商品名称', value: 'name', sortable: false, align: 'left' },
    { text: '容量', value: 'capacity', sortable: false, align: 'left' },
    {
      text: '入库数',
      value: 'quantity',
      align: 'right',
      sortable: false,
      width: 200,
      edit: () => {
        return this.isEdit();
      }
    },
    {
      text: '限用日期',
      value: 'productionDate',
      sortable: false,
      align: 'left',
      isDatePicker: () => {
        return this.isEdit();
      }
    }
  ];
  records = [
    { text: '操作者', value: 'operator', sortable: false, align: 'left' },
    { text: '操作时间', value: 'operateTime', isFormatDate: true, sortable: false, align: 'left' },
    { text: '操作类型', value: 'operateType', sortable: false, align: 'left' },
    {
      text: '说明',
      value: 'propetyChanges',
      sortable: false,
      align: 'left',
      render: (h: Function, param: any) => {
        let content = param.row[param.keyName].map((i: any) => {
          return h('span', `${i.propertyName} : 修改前 ${i.originalValue},修改后 ${i.newValue}`);
        });
        return h('div', content);
      }
    }
  ];

  get totalProducts() {
    if (!this.form.products) return 0;
    return this.form.products.filter((p: any) => {
      return p.id;
    }).length;
  }
  plus(a: number, b: number) {
    return a + b;
  }
  get totalQuantity(): number {
    if (!this.form.products) return 0;
    return this.form.products
      .map((item: any) => {
        return parseInt(item.quantity);
      })
      .reduce(this.plus, 0);
  }
  get isNoQuantity() {
    let error = false;
    this.form.products!.forEach((p: any) => {
      if (!p.quantity) {
        error = true;
      }
    });
    return error;
  }
  isEdit() {
    return !this.$route.query.isDetail;
  }
  created() {
    this.getFormData();
    this.getLog();
    // this.genbreadItems();
  }
  formatDate(date: Date) {
    return moment(date).format('YYYY-MM-DD');
  }
  getFormData() {
    getInstock(this.$route.query.id.toString()).then((data: any) => {
      this.form = data;
      this.form.products =
        this.form.products != null
          ? this.form.products.map((p: any) => {
              return Object.assign({}, p, { productionDate: p.productionDate ? moment(p.productionDate).format('YYYY-MM-DD') : null });
            })
          : [];
    });
  }
  getLog() {
    getStockLog(this.$route.query.id.toString()).then((data: any) => {
      this.logs = data.items;
    });
  }
  back() {
    this.$router.go(-1);
  }
  approve() {
    if (this.isNoQuantity) {
      AppStore.ShowError(`入库数量不能为空`);
      return;
    }
    this.dialog = true;
  }
  cancel() {
    this.dialog = false;
  }
  sure() {
    this.requestLoading = true;
    let formData = this.form.products!.map((p: any) => {
      return { productId: p.id, quantity: p.quantity, productionDate: p.productionDate };
    });
    approveStock(this.$route.query.id.toString(), formData)
      .then((data: any) => {
        this.$router.push({ name: 'inStock' });
        Utils.clearAllSearchPage(this.$route.name as string);
      })
      .catch()
      .finally(() => {
        this.dialog = false;
        this.requestLoading = false;
        Utils.clearAllSearchPage(this.$route.name as string);
      });
  }
  switchStatus(status: string) {
    switch (status) {
      case 'Pending':
        return '待审核';
      case 'Stocked':
        return '已入库';
    }
  }
  switchType(type: string) {
    switch (type) {
      case 'Purchase':
        return '采购入库';
      case 'Profit':
        return '盘盈入库';
      case 'Return':
        return '退货入库';
      case 'Transfer':
        return '调拨入库';
      case 'Other':
        return '其他入库';
    }
  }
}
